<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Serija C6100">
     Serija C6100
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_hr" title="Sigurnosne informacije">
     Sigurnosne informacije
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href="safety.html#d0e23" title="Pravila označavanja">
      Pravila označavanja
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_hr" title="Upoznavanje pisača">
     Upoznavanje pisača
    </a>
   </p>
   <div id="divd0e187">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_hr" title="Pronalaženje informacija o pisaču">
      Pronalaženje informacija o pisaču
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_hr" title="Odabir lokacije za pisač">
      Odabir lokacije za pisač
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configured-models-topic.html#configured-models_hr" title="Konfiguracije pisača">
      Konfiguracije pisača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_hr" title="Priključivanje kabela">
      Priključivanje kabela
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_hr" title="Upotreba upravljačke ploče">
      Upotreba upravljačke ploče
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-power-button-and-indicator-light-topic.html#understanding-status-power-button-and-indicator-light_hr" title="Razumijevanje statusa gumba za uključivanje/isključivanje i indikatora">
      Razumijevanje statusa gumba za uključivanje/isključivanje i indikatora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_hr" title="Upotreba početnog zaslona">
      Upotreba početnog zaslona
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-map-sfp-topic.html#menus-map-sfp_hr" title="Karta izbornika">
      Karta izbornika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_hr" title="Ispisivanje stranice s postavkama izbornika">
      Ispisivanje stranice s postavkama izbornika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_hr" title="Neprihvatljiv papir">
      Neprihvatljiv papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_hr" title="Upotreba recikliranog papira">
      Upotreba recikliranog papira
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_hr" title="Postavljanje i upotreba aplikacija na početnom zaslonu">
     Postavljanje i upotreba aplikacija na početnom zaslonu
    </a>
   </p>
   <div id="divd0e1161">
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_hr" title="Prilagodba početnog zaslona">
      Prilagodba početnog zaslona
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#using-display-customization_hr" title="Prilagodba zaslona">
      Prilagodba zaslona
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-forms-and-favorites-topic.html#setting-up-forms-and-favorites_hr" title="Postavljanje obrazaca i favorita">
      Postavljanje obrazaca i favorita
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-eco-settings-topic.html#configuring-eco-settings_hr" title="Konfiguriranje ekopostavki">
      Konfiguriranje ekopostavki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-customer-support-topic.html#using-customer-support_hr" title="Upotreba korisničke podr&scaron;ke">
      Upotreba korisničke podr&scaron;ke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-qr-code-generator-topic.html#using-qr-code-generator_hr" title="Upotreba generatora QR kodova">
      Upotreba generatora QR kodova
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-device-quotas-topic.html#setting-up-device-quotas_hr" title="Postavljanje kvota uređaja">
      Postavljanje kvota uređaja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-google-drive-topic.html#using-google-drive_hr" title="Upotreba usluge Google Drive">
      Upotreba usluge Google Drive
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-contacts-topic.html#d0e1389" title="Upravljanje kontaktima">
      Upravljanje kontaktima
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-accessibility-features-chapter.html#setting-up-using-accessibility-features-chapter_hr" title="Postavljanje i upotreba značajki za upravljanje pristupom">
     Postavljanje i upotreba značajki za upravljanje pristupom
    </a>
   </p>
   <div id="divd0e1508">
    <p class="toc-2-style">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode_hr" title="Omogućavanje načina rada povećanja">
      Omogućavanje načina rada povećanja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#activating-voice-guidance_hr" title="Uključivanje glasovnog navođenja">
      Uključivanje glasovnog navođenja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate_hr" title="Pode&scaron;avanje brzine govora glasovnog navođenja">
      Pode&scaron;avanje brzine govora glasovnog navođenja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers_hr" title="Omogućavanje izgovorenih lozinki ili osobnih identifikacijskih brojeva">
      Omogućavanje izgovorenih lozinki ili osobnih identifikacijskih brojeva
     </a>
    </p>
    <p class="toc-2-style">
     <a href="navigating-screen-using-gestures-topic.html#navigating-screen-using-gestures_hr" title="Kretanje zaslonom pomoću poteza">
      Kretanje zaslonom pomoću poteza
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-keyboard-on-display-topic.html#using-keyboard-on-display_hr" title="Upotreba zaslonske tipkovnice">
      Upotreba zaslonske tipkovnice
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_hr" title="Ulaganje papira i posebnih medija">
     Ulaganje papira i posebnih medija
    </a>
   </p>
   <div id="divd0e1711">
    <p class="toc-2-style">
     <a href="setting-paper-size-type-topic.html#setting-paper-size-type_hr" title="Postavljanje formata i vrste posebnih medija">
      Postavljanje formata i vrste posebnih medija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-m-topic.html#configuring-universal-paper-settings-m_hr" title="Konfiguriranje univerzalnih postavki papira">
      Konfiguriranje univerzalnih postavki papira
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_hr" title="Ulaganje u odlagače">
      Ulaganje u odlagače
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_hr" title="Ulaganje u ulagač za razne medije">
      Ulaganje u ulagač za razne medije
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_hr" title="Povezivanje odlagača">
      Povezivanje odlagača
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_hr" title="Ispisivanje">
     Ispisivanje
    </a>
   </p>
   <div id="divd0e1897">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_hr" title="Ispisivanje s računala">
      Ispisivanje s računala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-forms-topic.html#printing-forms_hr" title="Ispisivanje obrazaca">
      Ispisivanje obrazaca
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e1948" title="Ispisivanje s mobilnog uređaja">
      Ispisivanje s mobilnog uređaja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-h2-topic.html#printing-from-flash-drive-h2_hr" title="Ispisivanje s flash pogona">
      Ispisivanje s flash pogona
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_hr" title="Podržani flash pogoni i vrste datoteka">
      Podržani flash pogoni i vrste datoteka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_hr" title="Konfiguriranje povjerljivih zadataka">
      Konfiguriranje povjerljivih zadataka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-h-topic.html#printing-confidential-and-other-held-jobs-h_hr" title="Ispisivanje zadataka na čekanju">
      Ispisivanje zadataka na čekanju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_hr" title="Ispisivanje popisa uzoraka fontova">
      Ispisivanje popisa uzoraka fontova
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_hr" title="Otkazivanje zadatka ispisivanja">
      Otkazivanje zadatka ispisivanja
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_hr" title="Za&scaron;tita pisača">
     Za&scaron;tita pisača
    </a>
   </p>
   <div id="divd0e2338">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_hr" title="Lociranje sigurnosnog utora">
      Lociranje sigurnosnog utora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_hr" title="Brisanje memorije pisača">
      Brisanje memorije pisača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-topic.html#erasing-printer-hard-disk-memory_hr" title="Brisanje memorije tvrdog diska pisača">
      Brisanje memorije tvrdog diska pisača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-printer-hard-disk-encryption-topic.html#configuring-printer-hard-disk-encryption_hr" title="Konfiguriranje &scaron;ifriranja tvrdog diska pisača">
      Konfiguriranje &scaron;ifriranja tvrdog diska pisača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_hr" title="Vraćanje tvornički zadanih postavki">
      Vraćanje tvornički zadanih postavki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_hr" title="Izjava o postojanosti memorije">
      Izjava o postojanosti memorije
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_hr" title="Održavanje pisača">
     Održavanje pisača
    </a>
   </p>
   <div id="divd0e2548">
    <p class="toc-2-style">
     <a href="adjusting-default-internal-speaker-volume-topic.html#d0e2553" title="Prilagođavanje glasnoće zvučnika">
      Prilagođavanje glasnoće zvučnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-using-printer-control-panel-topic.html#d0e2645" title="Umrežavanje">
      Umrežavanje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_hr" title="Postavljanje ispisa putem serijskog priključka (samo sustav Windows)">
      Postavljanje ispisa putem serijskog priključka (samo sustav Windows)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_hr" title="Či&scaron;ćenje pisača">
      Či&scaron;ćenje pisača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_hr" title="Naručivanje dijelova i potro&scaron;nog materijala">
      Naručivanje dijelova i potro&scaron;nog materijala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-developer-unit-topic.html#d0e3210" title="Zamjena dijelova i potro&scaron;nog materijala">
      Zamjena dijelova i potro&scaron;nog materijala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="storing-supplies-topic.html#storing-supplies_hr" title="Pohrana potro&scaron;nog materijala">
      Pohrana potro&scaron;nog materijala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer-group.html#d0e3680" title="Premje&scaron;tanje pisača">
      Premje&scaron;tanje pisača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-energy-paper.html#d0e3736" title="&Scaron;tednja energije i papira">
      &Scaron;tednja energije i papira
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling.html#d0e3873" title="Recikliranje">
      Recikliranje
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_hr" title="Otklanjanje zaglavljenih papira">
     Otklanjanje zaglavljenih papira
    </a>
   </p>
   <div id="divd0e3927">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_hr" title="Izbjegavanje zaglavljivanja">
      Izbjegavanje zaglavljivanja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_hr" title="Pronalaženje mjesta zaglavljivanja">
      Pronalaženje mjesta zaglavljivanja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-trays-topic.html#jam-in-trays_hr" title="Zaglavljivanje papira u odlagačima">
      Zaglavljivanje papira u odlagačima
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jams-in-mpf-topic.html#jams-in-mpf_hr" title="Zaglavljeni papir u ulagaču za razne medije">
      Zaglavljeni papir u ulagaču za razne medije
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-standard-bin-topic.html#jam-in-standard-bin_hr" title="Zaglavljeni papir u standardnom odjeljku">
      Zaglavljeni papir u standardnom odjeljku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-door-b-topic.html#jam-in-door-b_hr" title="Zaglavljeni papir iza vrata&scaron;aca B">
      Zaglavljeni papir iza vrata&scaron;aca B
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-finisher-bin-topic.html#jam-in-finisher-bin_hr" title="Zaglavljeni papir u odjeljku sklopa za zavr&scaron;nu obradu">
      Zaglavljeni papir u odjeljku sklopa za zavr&scaron;nu obradu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="staple-jam-door-g-topic.html#staple-jam-door-g_hr" title="Zaglavljena klamerica iza vrata&scaron;ca G">
      Zaglavljena klamerica iza vrata&scaron;ca G
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_hr" title="Rje&scaron;avanje problema">
     Rje&scaron;avanje problema
    </a>
   </p>
   <div id="divd0e4271">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e4274" title="Problemi s mrežnom vezom">
      Problemi s mrežnom vezom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e4489" title="Problemi s hardverskim opcijama">
      Problemi s hardverskim opcijama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e4761" title="Problemi s potro&scaron;nim materijalom">
      Problemi s potro&scaron;nim materijalom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_hr" title="Problemi s ulaganjem papira">
      Problemi s ulaganjem papira
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_hr" title="Problemi s ispisivanjem">
      Problemi s ispisivanjem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#d0e7303" title="Problemi s kvalitetom boje">
      Problemi s kvalitetom boje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_hr" title="Obraćanje službi za korisničku podr&scaron;ku">
      Obraćanje službi za korisničku podr&scaron;ku
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_hr" title="Nadogradnja i migracija">
     Nadogradnja i migracija
    </a>
   </p>
   <div id="divd0e7537">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e7540" title="Hardver">
      Hardver
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e7866" title="Softver">
      Softver
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e7942" title="Programske datoteke">
      Programske datoteke
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_hr" title="Obavijesti">
     Obavijesti
    </a>
   </p>
   <div id="divd0e8011">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8014" title="Informacije o proizvodu">
      Informacije o proizvodu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8031" title="Obavijest o izdanju">
      Obavijest o izdanju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_hr" title="Za&scaron;titni znakovi">
      Za&scaron;titni znakovi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_hr" title="Napomene o licenciranju">
      Napomene o licenciranju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_hr" title="Razine emisije buke">
      Razine emisije buke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8119" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8146" title="Litij-ionska punjiva baterija">
      Litij-ionska punjiva baterija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_hr" title="Uredba (EU) 2023/1542">
      Uredba (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_hr" title="Vraćanje Lexmarkovih spremnika za ponovnu upotrebu i recikliranje">
      Vraćanje Lexmarkovih spremnika za ponovnu upotrebu i recikliranje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_hr" title="Obavijest o osjetljivosti na statički elektricitet">
      Obavijest o osjetljivosti na statički elektricitet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_hr" title="Informacije o temperaturi">
      Informacije o temperaturi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_hr" title="Obavijest o laseru">
      Obavijest o laseru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-advisory-label_hr" title="Naljepnica s upozorenjem o laseru">
      Naljepnica s upozorenjem o laseru
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue